import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PitchFormState {
    // Basic Details
    companyName: string;
    website: string;
    annualTurnover: string;
    industry: string[];
    industrySubcategory: string[];
    companyProfile: [];
    // POC Details
    contactName: string;
    contactDesignation: string;
    contactEmail: string;
    phoneNumber: string;

    // Business Details
    currentInternationalMarket: string[];
    marketEntryChannel: string[];
    targetMarkets: string[];
    otherMarketEntryChannel: string;
    expansionDetails: string;
    expansionDocument: [];
    otherBusinessSector: string;
    industryOptions: any[];
    subIndustryOptions: any[];
    // Form Metadata
    step: number;
}

const initialState: PitchFormState = {
    companyName: '',
    website: '',
    annualTurnover: '',
    industry: [],
    industrySubcategory: [],
    companyProfile: [],
    contactName: '',
    contactDesignation: '',
    contactEmail: '',
    phoneNumber: '',
    currentInternationalMarket: [],
    marketEntryChannel: [],
    otherMarketEntryChannel: '',
    targetMarkets: [],
    expansionDocument: [],
    expansionDetails: '',
    industryOptions: [],
    subIndustryOptions: [],
    otherBusinessSector: '',
    step: 0
};

const pitchFormSlice = createSlice({
    name: 'pitchForm',
    initialState,
    reducers: {
        updatePitchFormValues(
            state,
            action: PayloadAction<Partial<PitchFormState>>
        ) {
            Object.assign(state, action.payload);
        },
        setStep(state, action: PayloadAction<number>) {
            state.step = action.payload;
        },
        resetPitchForm() {
            return initialState;
        }
    }
});

export const { updatePitchFormValues, setStep, resetPitchForm } =
    pitchFormSlice.actions;

export default pitchFormSlice.reducer;
